<template>
    <sg-phone class="mt-3" new-user form-message="Введите номер телефона и выберите пароль" :form-elua-warning="isIOS"
        @done="onDone" />
</template>

<script>
    import pageMixin from './pageMixin'
    import SgPhone from '@/components/phone/SgPhone'

    export default {
        components: {
            SgPhone
        },
        mixins: [pageMixin],
        methods: {
            onDone() {
                this.$store.commit('SET_REGISTERED', true)
                this.$router.push({
                    name: 'wv-wireservices',
                    params: {
                        newUser: true
                    }
                })
            },
        },
        created() {
            if (this.$store.state.registered) {

                this.$eventBus.$emit('loader:show', {
                    overlay: true
                })
                this.$api.skipWire()
                    .then(query => {
                        this.regOk(query)
                    })
                    .catch(error => {
                        this.$eventBus.$emit('error', error)
                    })
                    .finally(() => {

                        this.$eventBus.$emit('loader:hide')
                    })
            } else {

                this.$eventBus.$emit('loader:show', {
                    overlay: true
                })

                this.$api.resetUser()
                    .catch(error => {
                        this.$eventBus.$emit('error', error)
                    })
                    .finally(() => {

                        this.$eventBus.$emit('loader:hide')
                    })
            }
        }
    }
</script>

<style>

</style>